
const initialState = {
  businessDetails:'' 
}

export default function productListView(state = initialState, action) {
  console.log(action,"action.type====>productList",action.payload)
  if(action.type==='Business_Details'){
    return {
      ...state,
      businessDetails:action.payload,
    }
  }
  return state;

}